import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AutenticarService } from './autenticar.service';

@Injectable()
export class AutenticarInterceptor implements HttpInterceptor {

    constructor(private injector: Injector) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const loginService = this.injector.get(AutenticarService);

        if (loginService.isLoggedIn()) {
            const authRequest = req.clone({
                setHeaders: {
                    Authorization: `Bearer ${loginService.getToken()}`,
                },
            });

            return next.handle(authRequest).pipe(
                tap(
                    () => {},
                    (err) => {
                        if (err instanceof HttpErrorResponse) {
                            if (err.status === 401) {
                                loginService.handleUnauthorized();
                            }
                        }
                    }
                )
            );
        }
        return next.handle(req).pipe();
    }
}
